import { render } from "./AuthorNameAndContactDetailsModal.vue?vue&type=template&id=4cef6899"
import script from "./AuthorNameAndContactDetailsModal.vue?vue&type=script&lang=js"
export * from "./AuthorNameAndContactDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__